var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('div',[(_vm.apiV3Order && _vm.apiV3Order.orderDisplayId)?_c('ApiOrderEditForm',{attrs:{"details":_vm.apiV3Order}}):_c('edit-page-gen',{attrs:{"options":_vm.options,"on-form-initialized":_vm.onFormInitialized}})],1):_c('div',[_c('SideNav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }